module.exports = __webpack_public_path__ + "img/Painting02.f30beb10.png";